export default "__VITE_ASSET__CrK2kvIm__"